import { Component, OnDestroy, inject, input } from '@angular/core';
import { Router } from '@angular/router';
import { Store } from '@ngrx/store';
import { ReplaySubject, takeUntil } from 'rxjs';

import { AppState } from 'app/types';

import { coreSelectors } from '../state';

@Component({
  selector: 'app-footer',
  templateUrl: './footer.component.html',
  styleUrls: ['./footer.component.scss'],
  standalone: false,
})
export class FooterComponent implements OnDestroy {
  private router = inject(Router);
  protected loggedKnowledgeUrl = 'https://us.scoot.app/web/admin/knowledge-base';
  protected guestKnowledgeUrl = 'https://us.scoot.app/knowledge-base';

  public readonly customStyle = input<string>();
  public isUserAuthed = false;
  public currentYear?: number;
  private destroyed$ = new ReplaySubject<boolean>(1);

  public constructor() {
    const store = inject<Store<AppState>>(Store);

    const d = new Date();
    this.currentYear = d.getFullYear();
    store
      .select(coreSelectors.getUser)
      .pipe(takeUntil(this.destroyed$))
      .subscribe(({ isGuest, user }) => (this.isUserAuthed = !isGuest && !!user));
  }

  public ngOnDestroy(): void {
    this.destroyed$.next(true);
    this.destroyed$.complete();
  }
}
